export const COMMENT_BADGE_WIDTH = 180;
export const COMMENT_BADGE_HEIGHT = 40;
export const SWEEP_GROUP_WIDTH = 220;
export const SWEEP_GROUP_COLLAPSED_BASE_HEIGHT = 44;
export const SWEEP_GROUP_COLLAPSED_BADGE_ROW_H = 16;
export const SWEEP_GROUP_COLLAPSED_BADGE_MARGIN = 4;
export const SWEEP_GROUP_COLLAPSED_BADGES_PER_ROW = 4;
/** @deprecated use getSweepGroupSize() which computes height dynamically */
export const SWEEP_GROUP_HEIGHT = 70;
export const SWEEP_GROUP_RUN_WIDTH = 96;
export const SWEEP_GROUP_RUN_HEIGHT = 36;
export const SWEEP_GROUP_PADDING_WIDTH = 24;
export const SWEEP_GROUP_PADDING_HEIGHT = 56;
export const DETAIL_PILL_WIDTH = 80;
export const DETAIL_PILL_HEIGHT = 28;
export const PLOT_NODE_WIDTH = 180;
export const PLOT_NODE_HEIGHT = 150;
export const PLOT_NODE_TITLE_HEIGHT = 24;
export const ALL_DATA_NODE_WIDTH = 320;
export const ALL_DATA_NODE_HEADER_HEIGHT = 40;
export const ALL_DATA_TABLE_ROW_HEIGHT = 24;
export const ALL_DATA_TABLE_MAX_VISIBLE = 6;

export function getAllDataNodeHeight(runCount: number): number {
  const rows = Math.min(Math.max(runCount, 1), ALL_DATA_TABLE_MAX_VISIBLE);
  return ALL_DATA_NODE_HEADER_HEIGHT + rows * ALL_DATA_TABLE_ROW_HEIGHT + 4;
}

/** @deprecated use getAllDataNodeHeight for dynamic sizing */
export const ALL_DATA_NODE_HEIGHT = ALL_DATA_NODE_HEADER_HEIGHT + ALL_DATA_TABLE_MAX_VISIBLE * ALL_DATA_TABLE_ROW_HEIGHT + 4;
export const REF_QTY_GROUP_WIDTH = 240;
export const REF_QTY_GROUP_MAX_VISIBLE_ROWS = 5;
export const REF_QTY_GROUP_ROW_HEIGHT = 22;
export const REF_QTY_GROUP_PADDING_HEIGHT = 16;
export const REF_QTY_GROUP_HEADER_HEIGHT = 24;
export const REF_QTY_GROUP_BUTTON_HEIGHT = 30;

export interface SweepGroupSizeInput {
  expanded?: boolean;
  runCount?: number;
}

export interface RefQuantityGroupSizeInput {
  expanded?: boolean;
  labelCount?: number;
  hasMeshButton?: boolean;
}

export function getSweepGroupSize({
  expanded,
  runCount = 0,
}: SweepGroupSizeInput = {}) {
  if (!expanded) {
    if (runCount > 0 && runCount <= 8) {
      const badgeRows = Math.ceil(runCount / SWEEP_GROUP_COLLAPSED_BADGES_PER_ROW);
      return {
        width: SWEEP_GROUP_WIDTH,
        height: SWEEP_GROUP_COLLAPSED_BASE_HEIGHT
          + SWEEP_GROUP_COLLAPSED_BADGE_MARGIN
          + badgeRows * SWEEP_GROUP_COLLAPSED_BADGE_ROW_H,
      };
    }
    return { width: SWEEP_GROUP_WIDTH, height: SWEEP_GROUP_COLLAPSED_BASE_HEIGHT };
  }

  const cols = Math.min(4, Math.max(2, Math.ceil(Math.sqrt(runCount))));
  const rows = Math.ceil(runCount / cols);
  return {
    width: cols * SWEEP_GROUP_RUN_WIDTH + SWEEP_GROUP_PADDING_WIDTH,
    height: rows * SWEEP_GROUP_RUN_HEIGHT + SWEEP_GROUP_PADDING_HEIGHT,
  };
}

export const SOURCE_GROUP_WIDTH = 200;
export const SOURCE_GROUP_COLLAPSED_BASE_HEIGHT = 44;
export const SOURCE_GROUP_COLLAPSED_PILL_ROW_H = 16;
export const SOURCE_GROUP_COLLAPSED_PILL_MARGIN = 4;
export const SOURCE_GROUP_EXPANDED_ROW_HEIGHT = 22;
export const SOURCE_GROUP_EXPANDED_PADDING_HEIGHT = 48;

export function getSourceGroupSize({
  expanded = false,
  nodeCount = 0,
}: { expanded?: boolean; nodeCount?: number } = {}) {
  if (!expanded) {
    if (nodeCount > 0 && nodeCount <= 6) {
      const pillRows = Math.ceil(nodeCount / 3);
      return {
        width: SOURCE_GROUP_WIDTH,
        height: SOURCE_GROUP_COLLAPSED_BASE_HEIGHT
          + SOURCE_GROUP_COLLAPSED_PILL_MARGIN
          + pillRows * SOURCE_GROUP_COLLAPSED_PILL_ROW_H,
      };
    }
    return { width: SOURCE_GROUP_WIDTH, height: SOURCE_GROUP_COLLAPSED_BASE_HEIGHT };
  }

  const rows = Math.min(nodeCount, 10);
  return {
    width: SOURCE_GROUP_WIDTH,
    height: rows * SOURCE_GROUP_EXPANDED_ROW_HEIGHT + SOURCE_GROUP_EXPANDED_PADDING_HEIGHT,
  };
}

export function getRefQuantityGroupSize({
  expanded = true,
  labelCount = 2,
  hasMeshButton = false,
}: RefQuantityGroupSizeInput = {}) {
  const baseHeight = REF_QTY_GROUP_PADDING_HEIGHT + REF_QTY_GROUP_HEADER_HEIGHT;
  if (!expanded) {
    return { width: REF_QTY_GROUP_WIDTH, height: baseHeight };
  }

  const visibleRows = Math.min(Math.max(labelCount, 1), REF_QTY_GROUP_MAX_VISIBLE_ROWS);
  return {
    width: REF_QTY_GROUP_WIDTH,
    height:
      baseHeight +
      visibleRows * REF_QTY_GROUP_ROW_HEIGHT +
      (hasMeshButton ? REF_QTY_GROUP_BUTTON_HEIGHT : 0),
  };
}
